module.exports = __webpack_public_path__ + "img/cover.d4e3806e.jpg";